export enum SubscriptionBulkAction {
  Delete = "Delete Subscriptions",
}
